var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDigitalItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.16667V0.5H7.16667V7.16667H0.5ZM2.16667 5.5H5.5V2.16667H2.16667V5.5ZM0.5 15.5V8.83333H7.16667V15.5H0.5ZM2.16667 13.8333H5.5V10.5H2.16667V13.8333ZM8.83333 7.16667V0.5H15.5V7.16667H8.83333ZM10.5 5.5H13.8333V2.16667H10.5V5.5ZM13.8333 15.5V13.8333H15.5V15.5H13.8333ZM8.83333 10.5V8.83333H10.5V10.5H8.83333ZM10.5 12.1667V10.5H12.1667V12.1667H10.5ZM8.83333 13.8333V12.1667H10.5V13.8333H8.83333ZM10.5 15.5V13.8333H12.1667V15.5H10.5ZM12.1667 13.8333V12.1667H13.8333V13.8333H12.1667ZM12.1667 10.5V8.83333H13.8333V10.5H12.1667ZM13.8333 12.1667V10.5H15.5V12.1667H13.8333Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDigitalItem);
export default __webpack_public_path__ + "static/media/icon-digital-item.88b58a0d1fedbe05b0fe062829a29ee3.svg";
export { ForwardRef as ReactComponent };